import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const gkeOptionsPlugin = createPlugin({
  id: 'gke-options',
  routes: {
    root: rootRouteRef,
  },
});

export const GkeOptionsPage = gkeOptionsPlugin.provide(
  createRoutableExtension({
    name: 'GkeOptionsPage',
    component: () => import('./components/GkeOptions').then(m => m.GkeOptions),
    mountPoint: rootRouteRef,
  }),
);

export const ExternalSecretPage = gkeOptionsPlugin.provide(
  createRoutableExtension({
    name: 'ExternalSecretPage',
    component: () =>
      import('./components/ExternalSecrets').then(m => m.ExternalSecret),
    mountPoint: rootRouteRef,
  }),
);

export const AddExternalSecretPage = gkeOptionsPlugin.provide(
  createRoutableExtension({
    name: 'AddExternalSecretPage',
    component: () =>
      import('./components/AddExternalSecret').then(m => m.AddExternalSecret),
    mountPoint: rootRouteRef,
  }),
);

export const InstallExternalSecretPage = gkeOptionsPlugin.provide(
  createRoutableExtension({
    name: 'InstallExternalSecretPage',
    component: () =>
      import('./components/InstallExternalSecret').then(
        m => m.InstallExternalSecret,
      ),
    mountPoint: rootRouteRef,
  }),
);
export const SetUpExternalSecretPage = gkeOptionsPlugin.provide(
  createRoutableExtension({
    name: 'SetUpExternalSecretPage',
    component: () =>
      import('./components/SetUpExternalSecret').then(
        m => m.SetUpExternalSecret,
      ),
    mountPoint: rootRouteRef,
  }),
);
